export const VISIBILITY_FILTERS = {
  ALL: 'all',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete'
};
let pageLimit = '5';
export const API_URL = process.env.REACT_APP_API_URL || '';
export const ROOT_ROUTE = process.env.REACT_APP_BASE_ROOT === '/' ? '' : process.env.REACT_APP_BASE_ROOT;
export const HOST_NAME = process.env.REACT_APP_HOST_NAME || '';
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN || '';
export const GA_ID = process.env.REACT_APP_GA_ID || 'UA-00000000-1';
export const EXHIBITION_ID = process.env.EXHIBITION_ID ? parseInt(process.env.EXHIBITION_ID) : 14455;
if (process.env.NODE_ENV !== 'development') {
  pageLimit = '20';
}
export const LIMIT_STEP = parseInt(process.env.REACT_APP_LIMIT_STEP || pageLimit);
export const API_PORT = process.env.NODE_ENV !== 'development' ? '80' : '443';
